import { render, staticRenderFns } from "./ConfigBackup.vue?vue&type=template&id=503d155a&scoped=true&"
import script from "./ConfigBackup.vue?vue&type=script&lang=js&"
export * from "./ConfigBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503d155a",
  null
  
)

export default component.exports